import React from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import FlatPagination from "material-ui-flat-pagination";
import { withAlert } from "react-alert";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Dropdown from "react-dropdown";
import * as _ from "lodash";
import BannerHead from "../BannerHead";
import {
  getAllSettlement,
  getAllFilteredSettlement,
  requestDismissSettlement
} from "../../Actions/actions";
import SearchText from "../common/searchtext";
import PlanStub from "../common/planStub";
import loader from "../../images/Spin-1s-107px.gif";

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class SettlementListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      a: [],
      b: [],
      offset: 0,
      total: 0,
      searcht: "",
      catgoryId: 0,
      sortBy: "",
      errors: {},
      isLoader: true,
      recursive: false,
      userid: localStorage.getItem("userId"),
      searchType: "All"
    };
    this.onChange = this.onChange.bind(this);
    this.filterSelect = this.filterSelect.bind(this);
    this.getStateData = this.getStateData.bind(this);
    this.child = React.createRef();
    this.TheLayerUpAnswerstoQuestions = this.TheLayerUpAnswerstoQuestions.bind(
      this
    );
  }

  TheLayerUpAnswerstoQuestions(data) {
    this.props.answerToQuestionAction(data);
  }

  onChange() {
    this.setState({ isLoader: true, offset: 0 });
    const result = {
      catgoryId: this.state.catgoryId,
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: this.state.searcht,
      sortBy: this.state.sortBy,
      userId: this.state.userid,
      searchType: this.state.searchType
    };
    this.props.getAllFilteredSettlement(result);
  }

  timer = null;

  handleChange = e => {
    clearTimeout(this.timer);

    this.setState({ searcht: e.target.value });

    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  triggerChange = e => {
    this.onChange(e);
  };

  /**
   * Filter Options
   */
  filterSelect(e, type) {
    const result = {
      catgoryId: this.state.catgoryId,
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: this.state.searcht,
      sortBy: this.state.sortBy,
      userId: this.state.userid,
      searchType: this.state.searchType
    };
    this.setState({ isLoader: true, [type]: e.value, offset: 0 });
    if (type === "catgoryId") {
      result.catgoryId = e.value;
    }

    result[[type]] = e.value;
    this.props.getAllFilteredSettlement(result);
  }

  /**
   * Pagination
   */
  handleClick(offset) {
    this.setState({ isLoader: true, offset });
    const pageNumber = offset / 5;
    const { searcht, sortBy, catgoryId, userid, searchType } = this.state;

    if (searcht !== "" && sortBy === "" && catgoryId === "") {
      this.props.getAllFilteredSettlement({
        catgoryId: 0,
        pageNumber,
        pageSize: 5,
        searchKeyword: searcht,
        sortBy: "",
        userId: userid,
        searchType
      });
    } else if (searcht !== "" && sortBy !== "" && catgoryId === "") {
      this.props.getAllFilteredSettlement({
        catgoryId: 0,
        pageNumber,
        pageSize: 5,
        searchKeyword: searcht,
        sortBy,
        userId: userid,
        searchType
      });
    } else if (searcht !== "" && sortBy !== "" && catgoryId !== "") {
      this.props.getAllFilteredSettlement({
        catgoryId,
        pageNumber,
        pageSize: 5,
        searchKeyword: searcht,
        sortBy,
        userId: userid,
        searchType
      });
    } else if (searcht === "" && sortBy !== "" && catgoryId === "") {
      this.props.getAllFilteredSettlement({
        catgoryId,
        pageNumber,
        pageSize: 5,
        searchKeyword: searcht,
        sortBy,
        userId: userid,
        searchType
      });
    } else if (searcht === "" && sortBy !== "" && catgoryId !== "") {
      this.props.getAllFilteredSettlement({
        catgoryId,
        pageNumber,
        pageSize: 5,
        searchKeyword: searcht,
        sortBy,
        userId: userid,
        searchType
      });
    } else if (searcht === "" && sortBy === "" && catgoryId !== "") {
      this.props.getAllFilteredSettlement({
        catgoryId,
        pageNumber,
        pageSize: 5,
        searchKeyword: searcht,
        sortBy,
        userId: userid,
        searchType
      });
    } else {
      this.props.getAllFilteredSettlement({
        pageNumber,
        pageSize: 5,
        searchKeyword: searcht,
        catgoryId,
        sortBy: "",
        userId: userid,
        searchType
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const allSettlementDatawe = nextProps.allSettlementDatawe
      ? nextProps.allSettlementDatawe
      : {};
    const allCategoryDatawe = nextProps.allCategoryDatawe
      ? nextProps.allCategoryDatawe
      : {};

    this.setState({ a: allCategoryDatawe, b: allSettlementDatawe });

    if (allSettlementDatawe !== undefined) {
      this.setState({ total: allSettlementDatawe.totalCount });
    }

    const confrimSettlement = nextProps.data.receiveDismissSettlement;
    if (typeof confrimSettlement !== "undefined") {
      if (confrimSettlement.code === 200) {
        const offset = this.state.offset;
        const pageNumber = offset / 5;
        if (this.state.recursive === true) {
          this.props.getAllFilteredSettlement({
            pageNumber,
            pageSize: 5,
            searchKeyword: this.state.searcht,
            catgoryId: 0,
            sortBy: "",
            userId: this.state.userid,
            searchType: this.state.searchType
          });
          this.setState({ recursive: false });
        }
      }
    }

    this.setState({ isLoader: false });
  }

  getStateData() {
    this.setState({ recursive: true, isLoader: true });
  }

  render() {
    const {
      searchType,
      searcht,
      errors,
      catgoryId,
      sortBy,
      a,
      b,
      isLoader,
      total
    } = this.state;

    let options = [
      {
        value: 0,
        label: "Select a category",
        name: "Select a category"
      }
    ];

    if (a.code === 400) {
      options = [];
    } else if (a !== undefined) {
      a.map(item =>
        options.push({
          value: item.categoryId,
          label: item.name,
          name: item.name
        })
      );
    }

    const cSelectedArra = _.find(options, { value: catgoryId });
    const cDefaultOption = cSelectedArra;

    const searchArray = [];
    searchArray.push({ value: "All", label: "All", name: "All" });
    searchArray.push({
      value: "Available",
      label: "Available",
      name: "Available"
    });
    searchArray.push({ value: "Dismiss", label: "Hidden", name: "Dismiss" });
    searchArray.push({ value: "Started", label: "Started", name: "Started" });

    const cSelectedSearch = _.find(searchArray, { value: searchType });
    const cDefaultSearch = cSelectedSearch;

    const sortArray = [
      {
        value: "",
        label: "Sort By",
        name: "Sort By"
      },
      {
        value: "Oldest",
        label: "Sort By Oldest",
        name: "Sort By Oldest"
      },
      {
        value: "Newest",
        label: "Sort By New",
        name: "Sort By Oldest"
      },
      {
        value: "Closing",
        label: "Sort By Ending Soon",
        name: "Sort By Ending Soon"
      }
    ];

    const cSelectedSort = _.find(sortArray, { value: sortBy });
    const cDefaultSort = cSelectedSort;

    const allSettlementDataweHtml = [];
    if (a.code === 400) {
      options = [];
    } else if (b !== undefined) {
      if (Object.keys(b).length > 0 && b.code !== 400) {
        if (b[0] === "NOT_FOUND") {
          allSettlementDataweHtml.push(
            <span>
              <li>No data available.</li>
            </span>
          );
        } else {
          b.records.map((item, index) => {
            const questionsList = item.eligibilityQuestionDtoList;
            let questionToDO = [];
            if (questionsList.length === 1) {
              questionToDO = questionsList;
            }

            allSettlementDataweHtml.push(
              <span key={`s${index}`}>
                <PlanStub
                  name={item.shortName}
                  dashboardIntroText={item.dashboardIntroText}
                  enrId={item.id}
                  price={item.totalMoneyAvailable}
                  tbdAmount={item.tbdAmount}
                  settlementDocumentDtoList={item}
                  item={item}
                  claimPeriodEndDate={
                    item.settlementImportantDateDto.claimPeriodEnd
                  }
                  hideClaimPeriodEnd={
                    item.settlementImportantDateDto.hideClaimPeriodEnd
                  }
                  type="settlement"
                  requestDismissSettlement={this.props.requestDismissSettlement}
                  dismissOption
                  searchType={this.state.searchType}
                  sendData={this.getStateData}
                  questionToDO={questionToDO}
                  AddTheFinalAnswer={this.TheLayerUpAnswerstoQuestions}
                  applySettelment={b.remainingSettlement}
                  // settlementTypeStatus={item.settlementStatusType}
                  applySettelmentStatus={item.enrollmentSettlementStatus}
                  ref={this.child}
                  PopErrorNotAllowedToMoveStatus={false}
                />
              </span>
            );
            return true;
          });
        }
      }
    }
    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    return (
      <span>
        {loader1}
        <div className="section-content dashboard settlment-listings">
          <div className="row">
            <div className="dashboard-tabs">
              <div className="row ">
                {/* <h3>{/* this.state.total */}
                <BannerHead title="Settlements" />

                <div className="settlemnt-search">
                  <div className="row">
                    <div className="input-field col s12 m12">
                      <SearchText
                        field="searcht"
                        placeholder="Search"
                        value={searcht}
                        error={errors.searcht}
                        onChange={this.handleChange}
                        onKeyDown={this.handleKeyDown}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col s12 m12 l9 settlement-button">
                      <Dropdown
                        name="searchType"
                        className="browser-default"
                        options={searchArray}
                        onChange={e => this.filterSelect(e, "searchType")}
                        value={cDefaultSearch}
                        placeholder="Select an option"
                      />

                      <Dropdown
                        name="catgoryId"
                        className="browser-default"
                        options={options}
                        onChange={e => this.filterSelect(e, "catgoryId")}
                        value={cDefaultOption}
                        placeholder="Select a category"
                      />
                      <Dropdown
                        name="sortBy"
                        className="browser-default"
                        options={sortArray}
                        onChange={e => this.filterSelect(e, "sortBy")}
                        value={cDefaultSort}
                        placeholder="Select an option"
                      />
                    </div>
                  </div>
                </div>

                <div
                  id="AllSettlemnet"
                  className="col s12 tab-data  settlement-dbdata active"
                >
                  {total === 0 || total === undefined ? (
                    this.props.response === true ? (
                      <ul>{allSettlementDataweHtml}</ul>
                    ) : (
                      ""
                    )
                  ) : (
                    <ul>
                      {allSettlementDataweHtml}
                      <MuiThemeProvider>
                        <FlatPagination
                          offset={this.state.offset}
                          limit={5}
                          total={this.state.total}
                          onClick={(e, offset) => this.handleClick(offset)}
                        />
                      </MuiThemeProvider>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

SettlementListComponent.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getAllSettlement, getAllFilteredSettlement, requestDismissSettlement },
    dispatch
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SettlementListComponent)
);
